<template>
  <div class="equities-create">
    <page-header header="Create IOI" />
    <edit-form
      ref="edit"
      :data="data"
      :error="error"
      @action="createIOI"
    />
  </div>
</template>

<script>
import EditForm from './Form'
import {successNotification} from '@/notifications'

const defaultData = () => {
  return {
    firmName: '',
    isin: '',
    securityName: '',
    exclude: '',
    expiry_date: null, // timestamp
    qualifierName: '',
    quantity: 0,
    price: 0,
    side: 'BUY',
  }
}

export default {
  components: {
    EditForm,
  },

  data () {
    return {
      error: null,
      data: defaultData(),
    }
  },

  methods: {
    async createIOI (ioi) {
      const userId = this.$login.getUser().id
      try {
        await this.$http.post('/iois/iois/add-ioi', ioi, {headers: {userId}})
        this.$router.replace('/equities')
        this.$notify(successNotification('Successfully created IOI'))
        this.error = null
        this.data = defaultData()
      } catch (error) {
        if (
          error.response &&
            error.response.data &&
            error.response.data.errors
        ) {
          this.error = error.response.data
        }
      }
    },
  },
}
</script>

